<template>
  <article>
    <v-card>
      <v-layout row wrap pa-3>
        <v-flex class="text-xs-center text-md-left" pa-1 xs12 sm6 md2>
          <div class="subheading grey--text">SLO Name</div>
          <div class="display-1">
            <router-link class="black--text" :to="{name: 'SLO', query: {id: slo.id}}">
              {{ slo.name }}
            </router-link>
          </div>
        </v-flex>
        <v-flex class="text-xs-center text-md-left" pa-1 xs12 sm6 md2>
          <div class="subheading">Current Level</div>
          <v-card flat>
            <div>
              <h3 :class="sloPctTextColor" class="display-2">{{ round(slo.currentPercent) }}%</h3>
            </div>
          </v-card>
        </v-flex>
        <v-flex pa-1 xs12 sm12 md6>
          <div class="subheading">Error Budget</div>
          <v-progress-linear height="40" :color="sloStatusColor" :value="pctBudgetLeft">
            <div class="white--text pa-3">
              {{ round(pctBudgetLeft) }}% Remaining
            </div>
          </v-progress-linear>
        </v-flex>
        <v-flex pa-3 xs12 md2>
          <v-layout row wrap>
            <v-flex class="text-xs-center text-sm-left" xs12 sm6>
              <v-card flat>
                <div class="subheading">
                  Target Level
                </div>
                <div>
                  <span class="headline grey--text">{{ slo.minPercent }}%</span>
                </div>
              </v-card>
            </v-flex>
            <v-flex class="text-xs-center text-sm-left" xs12 sm6>
              <v-card flat>
                <div class="subheading">SLO Period</div>
                <div>
                  <span class="headline">{{ sloPeriod }}</span>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </article>
</template>

<script>
export default {
  name: "sloSummary",
  props: {
    slo: {
      type: Object,
      required: true
    }
  },
  methods: {
    round(num) {
      return num.toFixed(2);
    }
  },
  computed: {
    sloStatusColor() {
      var total = this.slo.currentErrorBudget.totalBudget;

      if (total == 0.0) {
        return "grey";
      }

      if (this.pctBudgetLeft > 75.0) {
        return "success";
      }
      if (this.pctBudgetLeft > 30.0) {
        return "warning";
      }
      if (this.pctBudgetLeft <= 30.0) {
        return "error";
      }

      return "grey";
    },
    sloPctTextColor() {
      return this.sloStatusColor + "--text";
    },
    pctBudgetLeft() {
      var remaining = this.slo.currentErrorBudget.remainingBudget;
      var total = this.slo.currentErrorBudget.totalBudget;

      if (total == 0.0) {
        return 0.0;
      }

      return 100.0 * (remaining / total);
    },
    sloInDanger() {
      return this.pctBudgetLeft <= 30.0;
    },
    sloPeriod() {
      var days = Math.floor(this.slo.intervalHours / 24);
      var hours = this.slo.intervalHours % 24;
      var period = "";

      if (days === 0 && hours === 0) {
        return "0";
      }

      if (days > 0) {
        period += `${days} days`;
      }
      if (days > 0 && hours > 0) {
        period += ", ";
      }
      if (hours > 0) {
        period += `${hours} hours`;
      }

      return period;
    }
  }
};
</script>
